import { render } from "./GuardianSelectionModal.vue?vue&type=template&id=e758b0d0&scoped=true"
import script from "./GuardianSelectionModal.vue?vue&type=script&lang=js"
export * from "./GuardianSelectionModal.vue?vue&type=script&lang=js"

import "./GuardianSelectionModal.vue?vue&type=style&index=0&id=e758b0d0&lang=css"
import "./GuardianSelectionModal.vue?vue&type=style&index=1&id=e758b0d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e758b0d0"]])

export default __exports__